export const LANDING_SECTION = {
  SPALSH: "splash",
  ABOUT: "about",
  LANGUAGES: "languages",
  AUTHOR: "author",
  MORE_BOOKS: "MORE_BOOKS",
};
